import React from 'react'

const Placetable = () => {
  return (
    <div className='row justify-content-center'>
                    <div className='col-lg-10 placement-table'>
                    <table class="table">
                    <thead>
                                <tr>
                                <th scope="col">Student Name</th>
                                <th scope="col">Course</th>
                                <th scope="col">Placement Company</th>
                                <th scope="col">Location</th>
                                </tr>
                            </thead>
                         
<tbody>
    <tr><td>Divya</td><td>Analog Layout Design</td><td>Digicomm Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Kumar Nikhil</td><td>Physical Design</td><td>Lyptus Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Velavali Ruth Havila</td><td>Physical Design</td><td>SilivionAI Design</td><td>Bengaluru</td></tr>
    <tr><td>Ramadevi Vemula</td><td>Physical Design</td><td>SilivionAI Design</td><td>Bengaluru</td></tr>
    <tr><td>Boddupalli Anil Kumar</td><td>Physical Design</td><td>SilivionAI Design</td><td>Bengaluru</td></tr>
    <tr><td>Aisha Vatsh</td><td>Physical Design</td><td>Sauvira Solutions</td><td>Bengaluru</td></tr>
    <tr><td>BANDARUPALLI THRIVENI</td><td>Physical Design</td><td>Sauvira Solutions</td><td>Bengaluru</td></tr>
    <tr><td>RAGHU KERUR</td><td>ASIC Verification</td><td>HCL Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Manoj Kumar</td><td>Analog Layout Design</td><td>QubitSemi Solutions</td><td>Bengaluru</td></tr>
    <tr><td>Yelisetti venkatesh</td><td>Analog Layout Design</td><td>Juntran Technologies</td><td>Bengaluru</td></tr>
    <tr><td>MEENAKSHI K</td><td>ASIC Verification</td><td>SmartSoC Solutions</td><td>Bengaluru</td></tr>
    <tr><td>Tamilarasan E</td><td>Analog Layout Design</td><td>RAKIYA Information Technology Solution</td><td>Bengaluru</td></tr>
    <tr><td>Charan V</td><td>Analog Layout Design</td><td>Phyelements</td><td>Bengaluru</td></tr>
    <tr><td>ARUN KUMAR B J</td><td>Physical Design</td><td>Ample Semiconductors</td><td>Bengaluru</td></tr>
    <tr><td>Poornachandra M S</td><td>Analog Layout Design</td><td>Ambient Scientific</td><td>Bengaluru</td></tr>
    <tr><td>Poornima Priyadarshini J R</td><td>Analog Layout Design</td><td>SiyaCon Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Samarth Joshi</td><td>ASIC Verification</td><td>Excel VLSI Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Sangati Santosh Kumar Reddy</td><td>Analog Layout Design</td><td>Gaafet Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Sangati Santosh Kumar Reddy</td><td>Analog Layout Design</td><td>Gaafet Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Haritha S</td><td>Physical Design</td><td>Si14 Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Sangati Santosh Kumar Reddy</td><td>Analog Layout Design</td><td>Gaafet Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Bhimanadula Veera Satish</td><td>Analog Layout Design</td><td>Spintronics AI Semiconductors</td><td>Bengaluru</td></tr>
    <tr><td>Sathi Vikas</td><td>Physical Design</td><td>Chipnest Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Dasari Poornima</td><td>Physical Design</td><td>Chipnest Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Mudiyala Maheswar Reddy</td><td>Physical Design</td><td>Chipnest Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Regu Kavya</td><td>Physical Design</td><td>SIPP Crafters - VLSI Design House</td><td>Bengaluru</td></tr>
    <tr><td>Sabbavarapu satya sai varun</td><td>Analog Layout Design</td><td>GSVR semiconductors</td><td>Bengaluru</td></tr>
    <tr><td>DUPAGUNTLA ACHYUTH</td><td>Physical Design</td><td>Juntran Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Regati Ranjith Kumar</td><td>Physical Design</td><td>Stealth Startup</td><td>Bengaluru</td></tr>
    <tr><td>Sagar Ramachandra pattar</td><td>ASIC Verification</td><td>Juntran Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Mahalakshmi</td><td>Analog Layout Design</td><td>sanmina-sci india private limited</td><td>Bengaluru</td></tr>
    <tr><td>Sai Prasad Vaddi</td><td>ASIC Verification</td><td>Stealth Startup</td><td>Bengaluru</td></tr>
    <tr><td>Jakkula Bhavishya</td><td>Analog Layout Design</td><td>Gaafet Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Leesha GM</td><td>Analog Layout Design</td><td>MMRFIC TECHNOLOGY</td><td>Bengaluru</td></tr>
    <tr><td>Aditya Kumar Tiwari</td><td>Physical Design</td><td>Systechcorp Private Limited</td><td>Bengaluru</td></tr>
    <tr><td>BHARGAV RAM KESANI</td><td>Analog Layout Design</td><td>Spintronics AI Semiconductors</td><td>Bengaluru</td></tr>
    <tr><td>Satyam Yadav</td><td>ASIC Verification</td><td>Maverick Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Sachin Panduranga S</td><td>Analog Layout Design</td><td>Gaafet Semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Katari Jayaprakash</td><td>Physical Design</td><td>Route2soc semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Shaik Mukram</td><td>Physical Design</td><td>Trisemi Technologies</td><td>Bengaluru</td></tr>
    <tr><td>R Gunasekhar</td><td>Physical Design</td><td>Trisemi Technologies</td><td>Bengaluru</td></tr>
    <tr><td>Bhukya Gouthami</td><td>Physical Design</td><td>Route2soc semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>KAKI KRISHNA SAI DEEPAK</td><td>Physical Design</td><td>Route2soc semiconductor</td><td>Bengaluru</td></tr>
    <tr><td>Kalaivani K</td><td>Analog Layout Design</td><td>Tessolve Semiconductors</td><td>Bengaluru</td></tr>
    <tr><td>Shaik Saniya</td><td>ASIC Verification</td><td>Mervice Infotech</td><td>Bengaluru</td></tr>
<tr>
<td>Anusha B K</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sujit Kumar</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Amrita Sinha</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Tinku Kumar</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sharil Nivitha</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Janarthanan D</td>
<td>Design For Test</td>
<td>Waferspace</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ashrita Rao</td>
<td>ASIC Verification</td>
<td>UST Global</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nupur Dutta</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Noida</td>
</tr>
<tr>
<td>Deepti Tripathi</td>
<td>ASIC Verification</td>
<td>Radiant Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bala Bhandhavi</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vikram K</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Baskar S</td>
<td>Analog Circuit Design</td>
<td>Texas Instruments</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Srinivsa Ragavan R</td>
<td>Analog Circuit Design</td>
<td>Texas Instruments</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ranbir Singh</td>
<td>Physical Design</td>
<td>Cyient</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Sunil Kumar DC</td>
<td>Physical Design</td>
<td>Cyient</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Kodela Kishore Babu</td>
<td>Analog Layout Design</td>
<td>Cyient</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>S Tejaswani</td>
<td>Analog Circuit Design</td>
<td>Cyient</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Pradeep Kumar</td>
<td>Analog Circuit Design</td>
<td>ON Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vadla Siva Prasad</td>
<td>Analog Layout Design</td>
<td>Analog Port</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dattatraya H Nagaraj</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Birudula Priyanka</td>
<td>Physical Design</td>
<td>Einfochips</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Yerramreddy Mounika</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Iti Dutta</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Maddireddy Koti Reddy</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dhandamudi Sai Deepika</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sravani</td>
<td>Analog Circuit Design</td>
<td>ON Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Banoori Pooja Sri</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Lakshmi Sai Hemanth Dogiparthi</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ghouse Mohiddin U</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Madhira Jaya Shekar Reddy</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Meghana R</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Alok R Pandey</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Himavarsha Divvela</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Agnes Priya Dsouza</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ranjith. K</td>
<td>Analog Circuit Design</td>
<td>Maxim Integrated</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Jayasankar Ette</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sneha G S</td>
<td>Physical Design</td>
<td>L&amp;T Technologies Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shiva Kumar N C</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>K Siva Kumar</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Radhey Chintamani</td>
<td>ASIC Verification</td>
<td>Atria Logic</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Tammanaboina Sai Naga Siva Siddu</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Poojitha Linareddy</td>
<td>Physical Design</td>
<td>AMD</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bhargav K S</td>
<td>Analog Layout Design</td>
<td>HCL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Anisa Riyaz Mujawar</td>
<td>Analog Layout Design</td>
<td>HCL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Basavaraju</td>
<td>Analog Layout Design</td>
<td>HCL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Boya Pavani</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Acharya Vignesh</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gayathri Devi Narahari</td>
<td>Physical Design</td>
<td>HCL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Akash Deodurg</td>
<td>Analog Circuit Design</td>
<td>Intel</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Himanshu Singh</td>
<td>Design For Test</td>
<td>LeadSoc</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Naveen kumara K G</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Srinivasan Ganesan</td>
<td>Physical Design</td>
<td>Intel</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Apoorva H M</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ummadisetty Venkata Bhanu Sree</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prasad Chavan</td>
<td>Design For Test</td>
<td>Tessolve</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Harsh Mehta</td>
<td>Design For Test</td>
<td>Tessolve</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Eliyas</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>V Dhanasekar</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kottakota Saikiran</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Lakkuntla Rahul</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Narla Sindhuri</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prashob P</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Rahul Itnal</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mohamed Anas P</td>
<td>ASIC Verification</td>
<td>L&amp;T Technology Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nimeesh K</td>
<td>ASIC Verification</td>
<td>L&amp;T Technology Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Geetha N</td>
<td>Physical Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chepuri Rajinikanth</td>
<td>Physical Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nagendra Varma</td>
<td>Physical Design</td>
<td>Invecas</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Brunda G</td>
<td>Physical Design</td>
<td>HCL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mohammad Rafi</td>
<td>ASIC Verification</td>
<td>Agasthya App Labs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vennela V</td>
<td>Physical Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kavya Jambulingam</td>
<td>Physical Design</td>
<td>FLDEC Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mohd Arshad</td>
<td>Physical Design</td>
<td>G7N Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Radha S</td>
<td>Physical Design</td>
<td>Centaurs Semiconductors Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Konduru Srilakshmi</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Jaladi Sukanya</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Akash Verma</td>
<td>ASIC Verification</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Manjari Das</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shreesha N G</td>
<td>Physical Design</td>
<td>Signoff semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Raviteja Sanampudi</td>
<td>Analog Layout Design</td>
<td>Green PMU Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Santhoshini Komirishetty</td>
<td>Analog Layout Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Manjunath Gangadhar Hegde</td>
<td>Physical Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mudra Narasimha Rao</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>M Manusha</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gowthami R</td>
<td>Analog Circuit Design</td>
<td>Maxim Integrated</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Anwesha Paul</td>
<td>Physical Design</td>
<td>Einfochips</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Varudu Pavan Kalyan</td>
<td>Physical Design</td>
<td>L&amp;T Technologies Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chirumamilla Mounika</td>
<td>Physical Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chethana R</td>
<td>Analog Layout Design</td>
<td>Smart-DV</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Hemandu Kumar</td>
<td>Physical Design</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mandapally Shyam Sunder</td>
<td>Physical Design</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gollapothu Kiran Kumar</td>
<td>Physical Design</td>
<td>Krisemi Design Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shivani Patel</td>
<td>Physical Design</td>
<td>Krisemi Design Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sachin Bhardwaj</td>
<td>Analog Circuit Design</td>
<td>Maxim Integrated</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dodda Mensu Renuka</td>
<td>Physical Design</td>
<td>Krisemi Design Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Trephena Patricia</td>
<td>Physical Design</td>
<td>Krisemi Design Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Saibaba Sultan</td>
<td>Physical Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Apoorva Gupta</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pitta Kalyan Sai</td>
<td>Physical Design</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Mohammad Rafi</td>
<td>ASIC Verification</td>
<td>Agasthya App Labs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Peddi Viman Kumar</td>
<td>Physical Design</td>
<td>Agasthya App Labs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>N Jai Priya</td>
<td>Physical Design</td>
<td>Wafer Space</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vaishnavi Maddela</td>
<td>ASIC Verification</td>
<td>Aura Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Katta Anil</td>
<td>ASIC Verification</td>
<td>Open Silicon</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ranjith N G</td>
<td>Physical Design</td>
<td>Wafer Space</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mudiganti Geetha Madhuri</td>
<td>Physical Design</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pratikkumar Dineshbhai Mori</td>
<td>Analog Layout Design</td>
<td>KARMIC DESIGN</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Utti Bhavyashree</td>
<td>Analog Layout Design</td>
<td>MICRON</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prem Sagar</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Preetham</td>
<td>Design For Test</td>
<td>Synapse</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Manish Kumar</td>
<td>Design For Test</td>
<td>Synapse</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nisha T</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sangeeta Sharma</td>
<td>Analog Layout Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ananda Rao K</td>
<td>Physical Design</td>
<td>Intelligent &amp; Developed Products Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Jayanthi Vyshnavi</td>
<td>Physical Design</td>
<td>Krisemi Design Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Reshma Chandran</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Anagha U P</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chaithra M S</td>
<td>ASIC Verification</td>
<td>Laksh Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sanjay A K</td>
<td>ASIC Verification</td>
<td>Laksh Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Karthik R</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Divya K</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sharuk Dharwad</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vidyashree</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vidya Pawar</td>
<td>Design For Test</td>
<td>Cientra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Paban Mondal</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Goriparthi Gopikrishna</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Subash Krishna Radhakrishan</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thammireddy Revanth Kumar</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Logesh Kannan</td>
<td>Analog Circuit Design</td>
<td>Microchip</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Barla Rajeshwari</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kirana S</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sourav Garai</td>
<td>Physical Design</td>
<td>Signoff semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Tulasi Buddireddy</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>V Manasa</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chaithra B R</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gaurav Pandey</td>
<td>ASIC Verification</td>
<td>Aura Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shrinidhi S Amble</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Raya Adhikari</td>
<td>Analog Layout Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dasari Bhanu Krishna Raghava</td>
<td>Physical Design</td>
<td>Rakiya Information Technology Solution</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Eslavath Surendhar</td>
<td>Physical Design</td>
<td>SmartSoc</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bachhunavari Madhuri</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Munja Pranavi</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nerasala Bala Vengaiah</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bhargavi Katla</td>
<td>Physical Design</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Preethi Sharma</td>
<td>Analog Layout Design</td>
<td>PI Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sreepriya M</td>
<td>ASIC Verification</td>
<td>Open Silicon</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sayandeep Sen Gupta</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prajwal Shyadaguppi</td>
<td>Physical Design</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Borra Gopi Suresh</td>
<td>Analog Layout Design</td>
<td>Struent Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Deepak kumar singh</td>
<td>Design For Test</td>
<td>Synapse</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Lalithesh D</td>
<td>Physical Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Yekula Udaya keerthi</td>
<td>Physical Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Basavarajeshwari</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Jeevan Kishore J</td>
<td>Physical Design</td>
<td>DPIIND Services Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Anjali Mishra</td>
<td>Design For Test</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Girish B N</td>
<td>Physical Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Ayesha Khouser Usmani</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Eraganaboyina Pavan Kumar</td>
<td>Physical Design</td>
<td>Appose Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>K Pallavi</td>
<td>Design For Test</td>
<td>Waferspace</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Devesh Gaur</td>
<td>Design For Test</td>
<td>Waferspace</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sarita Uniyal</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pervez Ahmad</td>
<td>Physical Design</td>
<td>Meyvn Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Koijam Lemba Meitei</td>
<td>Analog Layout Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mocherla Vineela</td>
<td>Analog Layout Design</td>
<td>BEL</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>K Sudeep S Jain</td>
<td>Physical Design</td>
<td>Siemens</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Rihanabanu Rajabhksha Nadaf</td>
<td>Analog Layout Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Yashwanthkumar M</td>
<td>Analog Layout Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Neeraj Kumar</td>
<td>ASIC Verification</td>
<td>Open Silicon</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>J P Sooraj</td>
<td>Physical Design</td>
<td>SeviTech Systems Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dilip Kumar</td>
<td>Physical Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dinakar K</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Jhaghru Mahato</td>
<td>Analog Layout Design</td>
<td>IQZ Designs Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kotni Trinadh</td>
<td>Physical Design</td>
<td>SmartSoc</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chevula Chaitanya Krishna</td>
<td>Physical Design</td>
<td>Intelligent &amp; Developed Products Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Abhishek Kumar</td>
<td>Analog Layout Design</td>
<td>ARF Design Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sushree Priyadarsinee</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bakkathatla Naveen Kumar</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gajwelwar Akhil Goud</td>
<td>Physical Design</td>
<td>Cerium Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mithun Naik</td>
<td>Physical Design</td>
<td>Agasthya App Labs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ranganaboina Pavan Kumar</td>
<td>Physical Design</td>
<td>Siliciom Technologies Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ranjeet Kumar Verma</td>
<td>ASIC Verification</td>
<td>Cerium Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ashwini Mali</td>
<td>ASIC Verification</td>
<td>Cerium Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sonali Malviya</td>
<td>Analog Layout Design</td>
<td>Alten calsoft lab</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gururaj P Mathad</td>
<td>Analog Layout Design</td>
<td>ARF Design Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kolluri Sai Supriya</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bheesetti Shanmukha Murali Krishna</td>
<td>Physical Design</td>
<td>Makonis semicon private limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Yashavanth Kademani</td>
<td>Physical Design</td>
<td>Delancey Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sanjay</td>
<td>Analog Layout Design</td>
<td>IQZ Designs pvt ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Snehashree S</td>
<td>Physical Design</td>
<td>Centaurs Semiconductors Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Akhila Gopal K</td>
<td>Physical Design</td>
<td>Centaurs Semiconductors Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ankit Upadhyay</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ritesh Tiwari</td>
<td>ASIC Verification</td>
<td>Mirafra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pallakonda Rajarsha</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Noida</td>
</tr>
<tr>
<td>Suraj Kumar Manjhi</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thota Naveen</td>
<td>Physical Design</td>
<td>Thinsil Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Madhu V Laxmeshwar</td>
<td>Analog Layout Design</td>
<td>Green Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mirza Sadaq Hussain</td>
<td>Physical Design</td>
<td>Thinsil Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Komira Pooja</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nandini P</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Raghu Kumar R</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Uma Mishra</td>
<td>ASIC Verification</td>
<td>Mirafra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Suman S</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Srivatsa R</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ashwin Ashok Waghmare</td>
<td>Physical Design</td>
<td>Capgemini Engineering</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sothuku Preethi</td>
<td>ASIC Verification</td>
<td>ChipSolve Technologies Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Somnath Kulkarni</td>
<td>Analog Circuit Design</td>
<td>ROHM</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thambur Pushpa</td>
<td>ASIC Verification</td>
<td>ChipSolve Technologies Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sandeep Bisoi</td>
<td>Physical Design</td>
<td>Thinsil Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shubham Sabaji Parab</td>
<td>Physical Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bandela Manasa Reddy</td>
<td>Physical Design</td>
<td>Modernize Chip Solutions</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sachin Kumar</td>
<td>Physical Design</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Devi Sree R</td>
<td>ASIC Verification</td>
<td>Mirafra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bonthu Daiva Prasad</td>
<td>Physical Design</td>
<td>AIML Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dhruv Kumar</td>
<td>Physical Design</td>
<td>Thinsil Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sivanappa Hemamalini</td>
<td>Physical Design</td>
<td>Agasthya App Labs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sagarika</td>
<td>Physical Design</td>
<td>Modernize Chip Solutions</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Akash Mishra</td>
<td>Physical Design</td>
<td>Thinsil Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Addakula Keerthi</td>
<td>Physical Design</td>
<td>Vibhuaya technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Yoga Ranjani</td>
<td>ASIC Verification</td>
<td>Perfect VIPs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Narayana Reddy</td>
<td>ASIC Verification</td>
<td>Perfect VIPs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Arvapalli Divya Saiteja</td>
<td>Physical Design</td>
<td>ProXelera Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vennampally Karthik</td>
<td>Physical Design</td>
<td>Vibhuaya technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Naveen Gadiparthi</td>
<td>Physical Design</td>
<td>Chipware Technologies Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nagendra B V</td>
<td>Physical Design</td>
<td>Krish Semiconductors pvt ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Divi Satish Kumar</td>
<td>Physical Design</td>
<td>Krish Semiconductors pvt ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mandapalli Ajay kumar</td>
<td>Physical Design</td>
<td>Chipware Technologies Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sagar Sahu</td>
<td>ASIC Verification</td>
<td>Perfect VIPs</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kiran S K</td>
<td>Physical Design</td>
<td>Moslogi Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shashi Prabhu Yadav</td>
<td>Analog Layout Design</td>
<td>Milieudigital Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Donthagani Swami Sharan</td>
<td>Analog Layout Design</td>
<td>Logic Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kanthamani</td>
<td>Physical Design</td>
<td>Chiprime Semiconductor Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Susmitha Sharon</td>
<td>Analog Circuit Design</td>
<td>Microchip</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pallavi B H</td>
<td>Physical Design</td>
<td>Chiprime Semiconductor Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ediga Vijayanand Goud</td>
<td>Physical Design</td>
<td>Struent Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Arbin Akram</td>
<td>ASIC Verification</td>
<td>Chiprime Semiconductor Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ellapu Vara Lakshmi</td>
<td>Physical Design</td>
<td>KeenHeads Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chetan V Korishetter</td>
<td>Physical Design</td>
<td>KeenHeads Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sindhu P S</td>
<td>Analog Layout Design</td>
<td>ON Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gangasani Ashok Reddy</td>
<td>Analog Layout Design</td>
<td>ACL Digital</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Priyanka Nirwan</td>
<td>Design For Test</td>
<td>Tessolve</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Leesha Kumari</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Golla Deepak</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Saurabh Pandey</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pooja P N</td>
<td>Physical Design</td>
<td>Ambient Scientific</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Deepu Kumar</td>
<td>Analog Layout Design</td>
<td>Green Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vellaluru Sai Bhargav</td>
<td>Physical Design</td>
<td>Siliconus Technologies Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kurra Chandrayudu</td>
<td>Physical Design</td>
<td>Siliconus Technologies Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Renuka Bhardwaj</td>
<td>Analog Layout Design</td>
<td>Siliconch Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bhupathi Nagaraju</td>
<td>ASIC Verification</td>
<td>Atria Logic</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Shaju Afrin</td>
<td>Physical Design</td>
<td>Synapse Techno Design Innovations Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Abhimanyu kumar</td>
<td>Analog Layout Design</td>
<td>Synopsys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Suwarna Bajirao Dhiwar</td>
<td>Physical Design</td>
<td>NIKSPERRI TECHNOLOGIES PVT LTD</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sreepriya M</td>
<td>Analog Circuit Design</td>
<td>Texas Instruments</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Harsha Reddy</td>
<td>Analog Circuit Design</td>
<td>Texas Instruments</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pamisetty Udayabhanu</td>
<td>Physical Design</td>
<td>NIKSPERRI TECHNOLOGIES PVT LTD</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vallabhaneni Harshita</td>
<td>Physical Design</td>
<td>NIKSPERRI TECHNOLOGIES PVT LTD</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Relangi phani Kumar</td>
<td>Physical Design</td>
<td>Krish Semiconductors pvt ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kommula Sai Ashok</td>
<td>Physical Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Potluri Manikanta Reddy</td>
<td>Physical Design</td>
<td>Juntran Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Trishulpani Shrikant Kamati</td>
<td>Analog Layout Design</td>
<td>InSemi Technology Services Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>SINGIRI ADHARSH</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Noida</td>
</tr>
<tr>
<td>Samyuktha Shrruthi K R</td>
<td>Analog Layout Design</td>
<td>Insemi Technology Services Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>S Bharath</td>
<td>Design For Test</td>
<td>Exiger Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Akash G Maralihalli</td>
<td>Analog Layout Design</td>
<td>Insemi Technology Services Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prateek P Deshmukh</td>
<td>Analog Layout Design</td>
<td>Insemi Technology Services Pvt. Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nalladammigari Giri</td>
<td>Physical Design</td>
<td>AIML Services</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Priyanka S P</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Natrayan C</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Yashaswini C D</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kunal Jadhav</td>
<td>Design For Test</td>
<td>eInfochips</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dhanush Kollati</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sivakumar Nelloru</td>
<td>Physical Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>S Satya Narayana</td>
<td>Physical Design</td>
<td>Prime VLSI Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Venkata naveen kumar reddy</td>
<td>Physical Design</td>
<td>Prime VLSI Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gangadhar Bhavikatti</td>
<td>Analog Layout Design</td>
<td>Ambit Semiconductors Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Atharva J. Chopade</td>
<td>Analog Layout Design</td>
<td>Ambit Semiconductors Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mageswari M</td>
<td>Design For Test</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Swapnil Sunil Halgekar</td>
<td>Analog Layout Design</td>
<td>Ambit Semiconductors Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kodiboyina Indumathi</td>
<td>Physical Design</td>
<td>Smart SOC</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dodla Sai Krishna</td>
<td>Physical Design</td>
<td>Maverick Semiconductor Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nischitha B</td>
<td>Physical Design</td>
<td>Si-GPT</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mannam Krupa Rao</td>
<td>Analog Layout Design</td>
<td>RSK DESIGN PVT LTD</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sai kalyan yadav. B</td>
<td>Physical Design</td>
<td>Blueberry Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bonala sreekhar</td>
<td>Physical Design</td>
<td>Blueberry Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Asra Begum</td>
<td>Design For Test</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dudekula Gudampaty Shaikshavali</td>
<td>Physical Design</td>
<td>Blueberry Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kadiyala Harshavardhan</td>
<td>Physical Design</td>
<td>Blueberry Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dunna Koteswar Rao</td>
<td>Analog Layout Design</td>
<td>Gaafet Semiconductor Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ravindra Kumar Maurya</td>
<td>Analog Circuit Design</td>
<td>LeadIC Design pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kummara keerthana</td>
<td>Physical Design</td>
<td>SION Semiconductors Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>PAUL MATHEWS</td>
<td>Physical Design</td>
<td>Blueberry Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vaddi Nikhil</td>
<td>ASIC Verification</td>
<td>Anantha Software Solutions Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>S T P Sreeja</td>
<td>ASIC Verification</td>
<td>Anantha Software Solutions Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kummari Upendra</td>
<td>ASIC Verification</td>
<td>Aura Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nellore Deepthi</td>
<td>ASIC Verification</td>
<td>Anantha Software Solutions Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sri Vardhan Mudraboyina</td>
<td>Analog Layout Design</td>
<td>Analog Port Private Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Chandana M S</td>
<td>Analog Layout Design</td>
<td>Analog Port Private Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>G Shailesh Royal</td>
<td>Physical Design</td>
<td>BITSILICA</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Alladi Supraja</td>
<td>Physical Design</td>
<td>SpiderChip Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>M Mohamed Rahil</td>
<td>Analog Layout Design</td>
<td>Modernize Chip Solutions Pvt Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Manoj kumar</td>
<td>Design For Test</td>
<td>Cientra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Divya Krishnan</td>
<td>Design For Test</td>
<td>Cientra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shanmukha Prasanth Golla</td>
<td>Physical Design</td>
<td>Excel VLSI Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nerella Venkata Sai Samyuktha</td>
<td>Analog Layout Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Laam Jana Priya</td>
<td>Analog Layout Design</td>
<td>Tessolve Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Rizwana</td>
<td>Physical Design</td>
<td>New siliconage pvt ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>kastulapuri Bhavana</td>
<td>Analog Layout Design</td>
<td>LeadIC Design pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Gudipati Sneha</td>
<td>Physical Design</td>
<td>Cadence Design Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Vemula sarika</td>
<td>Physical Design</td>
<td>Cadence Design Systems</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sweta Sharma</td>
<td>Design For Test</td>
<td>eInfochips</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mahadev P. Jadhav</td>
<td>Physical Design</td>
<td>Quest Global</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mano Shivaraj C</td>
<td>Analog Layout Design</td>
<td>Terminus circuit pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sasapu Eswara Rao</td>
<td>Physical Design</td>
<td>BITSILICA</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>N V Yuktha Sri</td>
<td>ASIC Verification</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nitesh Rana</td>
<td>Design For Test</td>
<td>SkandySys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shivashankrayya Hiremath</td>
<td>Analog Layout Design</td>
<td>G7N Semiconductors private limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Duda Yamuna</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Noida</td>
</tr>
<tr>
<td>Dharavath Swathi</td>
<td>Physical Design</td>
<td>Truechip Solutions Pvt Ltd</td>
<td>Noida</td>
</tr>
<tr>
<td>Atul Maurya</td>
<td>Design For Test</td>
<td>eInfochips</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ravindra Talari</td>
<td>ASIC Verification</td>
<td>Quest Global</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shrikant Narayana Gouda</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thotakura Ramesh</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Syamala Nandini</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sudeep Krishnakumar Naik</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thigulla Anjali Devi</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Devarapalle Daivakrupa</td>
<td>Analog Layout Design</td>
<td>Wipro Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Soundarya R</td>
<td>Physical Design</td>
<td>Synopsys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Indrani</td>
<td>Design For Test</td>
<td>Cientra</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>TATA VENKATA SRI RAJENDRA PRASAD</td>
<td>Physical Design</td>
<td>Synopsys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Thikkala sanjay kumar</td>
<td>Physical Design</td>
<td>Synopsys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kummari Guru Mohan</td>
<td>Physical Design</td>
<td>Intel</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>GUMMOJI VENKATA LOKNATH</td>
<td>Physical Design</td>
<td>Intel</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>GUDIPATI VENKATA RAKESH</td>
<td>Physical Design</td>
<td>Astrasilica Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>ULLI PARAMESH</td>
<td>Physical Design</td>
<td>Advance Logics</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>HARISH NATARAJAN</td>
<td>ASIC Verification</td>
<td>Chipsolve Technologies</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Dhekolkar Amar Kallappa</td>
<td>Analog Layout Design</td>
<td>LeadIC Design pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Madhurima Kundu</td>
<td>Physical Design</td>
<td>Chipsolve Technologies</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>K Gayathri</td>
<td>Design For Test</td>
<td>SkandySys</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Epuri Yaswanth</td>
<td>Analog Layout Design</td>
<td>Cadence</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bandari Endu Varshitha</td>
<td>Analog Layout Design</td>
<td>Cadence</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Tarun S</td>
<td>Physical Design</td>
<td>HCL Tech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Santhosh K</td>
<td>Design For Test</td>
<td>Exiger Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Merva Pranavi</td>
<td>Physical Design</td>
<td>HCL Tech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Bajamma</td>
<td>Physical Design</td>
<td>HCL Tech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mallela Prasanna</td>
<td>Physical Design</td>
<td>HCL Tech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Umesh Prasad S</td>
<td>Analog Circuit Design</td>
<td>Insemi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pasula Sashidhar</td>
<td>ASIC Verification</td>
<td>Chipsolve Technologies</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Kesava Gompa</td>
<td>Physical Design</td>
<td>GSVR Talent Solutions Pvt Ltd</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>HITHESH V</td>
<td>Physical Design</td>
<td>GSVR Talent Solutions Pvt Ltd</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Meenakshi</td>
<td>Design For Test</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Soniya V</td>
<td>Physical Design</td>
<td>GSVR Talent Solutions Pvt Ltd</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Thrinadh Komatipalli</td>
<td>Physical Design</td>
<td>GSVR Talent Solutions Pvt Ltd</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Utkarsha onkareshwar Warghane</td>
<td>Analog Layout Design</td>
<td>Sim2Silicon Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Nivedita</td>
<td>Analog Circuit Design</td>
<td>Microchip</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mohith Yadav</td>
<td>Analog Circuit Design</td>
<td>Microchip</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>KULDEEP DUTTA</td>
<td>Analog Circuit Design</td>
<td>Radiant Semiconductors Pvt.Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Rakshika N</td>
<td>Physical Design</td>
<td>SmartIC Technologies Pvt Ltd.</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Dommaraju Venkata Sai Preetham</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Kochi</td>
</tr>
<tr>
<td>Midhun Sanapala</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Kochi</td>
</tr>
<tr>
<td>Narasimha Raju Sarikonda</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Kochi</td>
</tr>
<tr>
<td>Pankaj Pathak</td>
<td>Design For Test</td>
<td>Insemi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>P BHASKAR REDDY</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Kochi</td>
</tr>
<tr>
<td>Riteesh</td>
<td>Design For Test</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Tandra venkata narasimha shreyesh</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Kochi</td>
</tr>
<tr>
<td>MARADANA HYNDHAVI</td>
<td>ASIC Verification</td>
<td>Apex Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>BOYA YERRISWAMY</td>
<td>Physical Design</td>
<td>Siliconus Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Bairi Akhila</td>
<td>Analog Layout Design</td>
<td>Logicsemi Technologies Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>SANDHYA MINJ</td>
<td>Analog Layout Design</td>
<td>Logicsemi Technologies Pvt. Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Harshit Sharma</td>
<td>Design For Test</td>
<td>LeadSoc</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Prashantha B</td>
<td>Analog Circuit Design</td>
<td>Insemi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Kore Madhumitha</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>SHIRISHA CHALASANI</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Pune</td>
</tr>
<tr>
<td>Vikash Kumar</td>
<td>Design For Test</td>
<td>LeadSoc</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Mamilla Sharath Kumar Reddy</td>
<td>Physical Design</td>
<td>Wipro Limited</td>
<td>Pune</td>
</tr>
<tr>
<td>Leela Krishna</td>
<td>Design For Test</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Siddharth</td>
<td>Design For Test</td>
<td>P2F Semi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ehteshamul Haque</td>
<td>Physical Design</td>
<td>SION Semiconductors Private Limited</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Aviral Yadav</td>
<td>Design For Test</td>
<td>Exiger Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Boggavarapu Ravi Sankar gupta</td>
<td>ASIC Verification</td>
<td>Appex Semiconductors</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Neha Ghosh</td>
<td>Design For Test</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Sumit Kumar</td>
<td>Design For Test</td>
<td>Incise Infotech</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Ashwini Beli</td>
<td>Design For Test</td>
<td>Insemi</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Pulicharla Naveen Kumar Reddy</td>
<td>Analog Layout Design</td>
<td>Siliconus Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Darshan Krishna Jalisatgi</td>
<td>Analog Layout Design</td>
<td>Siliconus Technologies Pvt Ltd</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shivam Verma</td>
<td>Design For Test</td>
<td>Digicomm Semiconductor</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Shaik Ezzaz</td>
<td>ASIC Verification</td>
<td>Chipsolve Technologies</td>
<td>Hyderabad</td>
</tr>
<tr>
<td>Rahul Kumar Yadav</td>
<td>Design For Test</td>
<td>Pozibility Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
<td>Swetha U</td>
<td>Design For Test</td>
<td>Pozibility Technologies</td>
<td>Bengaluru</td>
</tr>
<tr>
    <td>BOYA YERRISWAMY</td>
    <td>Physical Design</td>
    <td>Siliconus Technologies</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Yelampalle Saikiran reddy</td>
    <td>ASIC Verification</td>
    <td>Truechip Solutions Pvt Ltd</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>KALYANI YENNAPU</td>
    <td>Physical Design</td>
    <td>SmartSoC Solutions Pvt Ltd</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Badiga Naga Sai Kumar</td>
    <td>ASIC Verification</td>
    <td>Maverick Semiconductor Pvt. Ltd</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Yalla Dhatri Parimala</td>
    <td>Physical Design</td>
    <td>ADVLOGICS</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Vaishnavi R Jogur</td>
    <td>Physical Design</td>
    <td>Quest Global</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Karan Khatwani</td>
    <td>Analog Layout Design</td>
    <td>Ample Semiconductors Pvt Ltd</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Rahul Nautiyal</td>
    <td>Physical Design</td>
    <td>Dligent Semiconductor</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Thippatagari Gowthami</td>
    <td>ASIC Verification</td>
    <td>GVSR Semiconductors</td>
    <td>Bengaluru</td>
</tr>
<tr>
    <td>Harika Peddakotla</td>
    <td>Physical Design</td>
    <td>Route2soc Semiconductor</td>
    <td>Bengaluru</td>
</tr>
</tbody>
                            </table>
                  </div>
                </div>
  )
}

export default Placetable